import { z } from "zod";

export const HostnameRegex = /^[A-Za-z0-9][A-Za-z0-9._-]*$/;
export const Ipv4Regex = /^\d{1,3}(\.\d{1,3}){3}$/;
export const FullVersionRegex = /^\d+\.\d+\.\d+\.\d+$/;

export const StringArray = z.array(z.string().min(1)).max(64);

export const RoleSchema = z.enum(["admin", "operator", "viewer"]);
export type Role = z.infer<typeof RoleSchema>;

export const OperationStatusSchema = z.enum([
	"running",
	"succeeded",
	"failed",
	"cancelled",
]);
export type OperationStatus = z.infer<typeof OperationStatusSchema>;

export const ApiErrorSchema = z.object({
	success: z.literal(false),
	error: z.object({
		code: z.string(),
		message: z.string(),
	}),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;
